import styles from "./styles.module.css";
import {
  MetaAplicacao,
  MetaFisica,
} from "../../../model/PlanoDeTrabalho/CronogramaExecucao";

type Props = {
  appObj: MetaAplicacao;
  metaFisica: MetaFisica;
  children?: any;
};

const RowAplicacao = ({ appObj, metaFisica, children }: Props) => {
  return (
    <tr className={styles.row}>
      <td
        className={styles.center}
      >{`${metaFisica.etapa}.${metaFisica.fase}`}</td>
      <td className={styles.text}>{appObj.especificacao}</td>
      <td className={styles.center}>{appObj.valor_orgao_entidade}</td>
      <td className={styles.center}>
        {appObj.valor_organizacao_sociedade_civil}
      </td>
      {children && <td className={styles.btncoll}>{children}</td>}
    </tr>
  );
};
export default RowAplicacao;
